import { useAuthStore } from '@/stores/auth'
import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { storeToRefs } from 'pinia'
import Api from '@/api'

const requiresAuthentication = async () => {
  const { isAuthenticated } = storeToRefs(useAuthStore())

  try {
    if (!isAuthenticated.value) await Api.getAuth()
  } catch (error: any) {
    const status = error.response?.status
    if (status === 401 || status === 403) {
      // Error will be shown by the error interceptor via notificationStore
      return { name: 'home' }
    }
    // For other errors, let them propagate (they're handled by interceptor)
    return { name: 'home' }
  }

  if (!isAuthenticated.value) return { name: 'home' }
}

const checkAuthenticated = () => {
  const { isAuthenticated } = storeToRefs(useAuthStore())
  if (isAuthenticated.value) return { name: 'admin' }
  else {
    window.location.href = `${Api.AUTH_URL}/login`
    return { name: 'home' }
  }
}

const requiresUserManagementAccess = () => {
  const { hasUserManagementAccess } = storeToRefs(useAuthStore())
  if (!hasUserManagementAccess.value) return { name: 'dashboard' }
}

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView
    },
    {
      path: '/login',
      name: 'login',
      beforeEnter: [checkAuthenticated],
      component: () => import('../views/AdminView.vue')
    },
    {
      path: '/logout',
      name: 'logout',
      component: HomeView,
      beforeEnter: () => {
        useAuthStore().clearUser()
        window.location.replace(`${Api.AUTH_URL}/logout`)
        return false
      }
    },
    {
      path: '/admin',
      name: 'admin',
      beforeEnter: [requiresAuthentication],
      component: () => import('../views/AdminView.vue'),
      children: [
        {
          path: ':projectOrigin?',
          children: [
            {
              path: ':projectName?',
              children: [
                {
                  path: '',
                  name: 'dashboard',
                  component: () => import('../views/DashboardView.vue')
                },
                {
                  path: 'annotation',
                  name: 'annotation',
                  component: () => import('../views/AnnotationView.vue')
                },
                {
                  path: 'taxonomy',
                  name: 'taxonomy',
                  component: () => import('../views/TaxonomyView.vue')
                },
                {
                  path: 'feedback',
                  name: 'feedback',
                  component: () => import('../views/FeedbackView.vue')
                },
                {
                  path: 'model',
                  name: 'model',
                  component: () => import('../views/ModelView.vue')
                }
              ]
            },
            {
              path: 'user-account',
              name: 'user-account',
              beforeEnter: [requiresUserManagementAccess],
              component: () => import('../views/UserAccountView.vue')
            }
          ]
        }
      ]
    }
  ]
})

export default router
